export default __webpack_public_path__ + "3ff949b66d2575652172c26fda11a75b.woff";